import { getQuery } from './request';
export async function fetchModuleList(moduleListName) {
  return getQuery(moduleListName);
}



// WEBPACK FOOTER //
// ./src/util/fetch-meta.js